import api from '@/plugins/api'
import requestValidation from '@/configs/requestValidation'
import {inspection as endpoint} from '@/configs/endpoints'
//
// const store = 'measurementNoise'


export default {
  state: () => ({
    isLoad: false,
  }),
  actions: {
    async createNoiseMeasurement (context, data) {
      const params = {
        number: data.number,
        type: 'noise',
      }
      const response = await api.post(endpoint.equipment(params), {body: data})
      
      if (await requestValidation(response)) {
        return response
      }
    },
    async checkNoiseMeasurement (context, data) {
      const params = {
        id: data.id,
        number: data.number,
        type: 'noise',
      }
      const response = await api.get(endpoint.equipment(params))

      if (await requestValidation(response)) {
        return response.data
      }
    },
    async startNoiseMeasurement (context, id) {
      const params = {
        id: id,
        type: 'noise'
      }
      const response = await api.post(endpoint.nextMeasurement(params))
      
      if (await requestValidation(response)) {
        return response
      }
    }
  },
  getters: {
  }
}
